export { FloatingLabel } from './FloatingLabel';
